import { createAction } from 'redux-actions';

export const updateEngagementFields = createAction('UPDATE_ENGAGEMENT_FIELDS');
export const setEngagement = createAction('SET_ENGAGEMENT');
